export default {
  data: [],
  aggregatedData: [],
  headers: []
};
